import axios from 'axios'
let extentFns = ['add', 'sub', 'mul', 'div'];
//运算函数
function ufunc(type, arg){
  var decimalDigits = []; //要计算的小数位数数组
  //获取小数点的位数
  for(let index in arg){
    let digit = 0;
    try {  
      digit = arg[index].toString().split(".")[1].length;
    }catch (e) { 
      digit = 0; 
    }
    decimalDigits.push(digit);
  }
  //找到最大的位数
  decimalDigits.sort( (a, b)=> a - b );
  let maxDigit = decimalDigits[decimalDigits.length - 1];
  let m = Math.pow(10, maxDigit);//小数转换成整数需要扩大的倍数
  let result = 0;
  switch(type){
    case 'add':
      for(let index in arg){
        result += arg[index] * m;
      }
      return result / m;
      break;
    case 'sub':
      for(let index in arg){
        if(index == 0){
          result = arg[index] * m - result;
        }else{
          result -= arg[index] * m
        }       
      }
      return result / m;
      break;
    case 'mul':
      result = 1;
      for(let index in arg){
        if(index == 0){
          result = arg[index] * m * result;
        }else{
          result *= arg[index] * m
        }       
      }
      return result / Math.pow(m,arg.length);
      break;
    case 'div':
      result = 1;
      for(let index in arg){
        if(index == 0){
          result = arg[index] * m / result;
        }else{
          result /= arg[index] * m
        }       
      }
      return result / Math.pow(m,arg.length);
      break;
    default:
      break;
      
  }
}

var wh = {
    randomId (hashLength = 16) {
        if (!hashLength || typeof(Number(hashLength)) != 'number') {return;}
        var ar = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        var hs = [];
        var hl = Number(hashLength);
        var al = ar.length;
        for (var i = 0; i < hl; i ++) {
            hs.push(ar[Math.floor(Math.random() * al)]);
        }
         
        return hs.join('');
    },
    waitingFetch () {
        let flag = false,_call,_overCall,_catchCall,time = 0
        var fetchTimer = null,
            catchTimer = null
      function start(url, option) {
            catchTimer = setTimeout(() => {
              clearInterval(fetchTimer)
              fetchTimer = null
              _catchCall && _catchCall()
              time = 0
            }, 1000 * 10);
            fetchTimer = setInterval(_ => {
                if (time >= 60) {
                    _overCall && _overCall()
                    clearInterval(fetchTimer)
                    time = 0
                    return 
                }
                axios({
                    url,
                    option
                }).then(res => {
                    clearTimeout(catchTimer)
                    if (res.data.data.payOk) {
                        flag = true
                        clearInterval(fetchTimer)
                    } else {
                        flag = false
                    }
                    _call && _call(res,flag)
                    time += 2
                })
            },2000) 
        }
        return (url,option)=>({
            then (call) {
                if (fetchTimer) return
                _call = call
                start(url,option)
                return this
            },
            overtime (call) {
                _overCall = call
                return this
            },
            catch (call){
              _catchCall = call
              return this
            },
            clear () {
                clearInterval(fetchTimer)
                fetchTimer = null
                return this
            }
        })
        
    },
    ufunc,
    mobileBroswerIdentify () {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
            return false
        } else {
            return true
        }

    },
    deSerialize (str) {
        if (!str) return ''
        str = str.split('')
        let b = str[0]
        str[0] = str[str.length - 1]
        str[str.length - 1] = b
        console.log(str)
        for (let i = 1; i < str.length; i++) {
            if (i % 2 == 1) {
                let a = str[i - 1]
                str[i - 1] = str[i]
                str[i] = a
            }
        }
        console.log(str.join(''))
        var decode = atob(str.join(''));
        return decodeURI(decode);
    },
    base64ToString(base64){
        // 对base64转编码
        var decode = atob(base64);
        // 编码转字符串
        var str = decodeURI(decode);
        return str;
    },
    disDeepClone (x) {
        return JSON.parse(JSON.stringify(x))
    },
    triggerOnce () {
        let num = 0
        return function (call) {
            if (num === 0) {
                num++
                call && call()
            }
        }
    },
    usStockIdentityType (question, job, isjg) {
        
        const job_list = [
            '企业普通职员（非金融相关）',
            '自由职业者',
            '其它职业',
            '无业',
            '证券 / 期货交易员',
            '投资顾问',
            '资产管理人',
            '金融机构分析师',
            '企业投融资专员',
            '金融监管机构相关职员',
            '大宗商品贸易风控专员',
            '私募 / 公募基金从业人员'
        ]
        let job_index = job_list.findIndex(v => v == job)
        let question_arr = question.split(',').map(v => v.split(' '))
        return job_index > 3 || isjg == 1 || question_arr.some(v => v[v.length - 1] == '是') 
    }
}
//挂载到Math上
// Math.add1 = add1;
for(let i = 0; i < extentFns.length; i++){
    wh[extentFns[i]] = function(){
        return this.ufunc(extentFns[i], arguments);
    };
}
export default wh
